import { FC } from 'react'

interface IProps {
  handleNew: () => void
  handleExportToCsv: () => void
}

const ActionButtons: FC<IProps> = ({ handleNew, handleExportToCsv }) => {
  return (
    <>
        <button className='btn btn-primary mr-2' onClick={handleNew}>
          Toevoegen Productafmeting
        </button>
        <button className='btn btn-secondary' onClick={handleExportToCsv}>
          Exporteren naar CSV
        </button>
    </>
  )
}

export default ActionButtons
